import React from "react";
import { Button, List } from "semantic-ui-react";
import { Grid } from "lib/index";
import createStripeSettingsView from "modules/settings/createStripeSettingsView";
import { StripeRepository } from "lib/repositories/index";
import { stateSelector, initializeView, updateModel, submit } from "./index";
import Hint from "./StripeSettingsHint";
import { createAlert } from "modules/app/actions";
import store from "app/store";

class FormContent extends React.PureComponent {
  state = {
    stripeSummary: undefined,
    isLoaded: !st.authorize.company.stripe_id,
  };
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const slug = window.location.href.substring(window.location.href.lastIndexOf("/") + 1);
    if (slug === "success") {
      store.dispatch(
        createAlert({
          uuid: "FETCH_STRIPE",
          type: "success",
          content: "Registration has been completed, please wait for the status to be updated",
          timeout: 10000,
        })
      );
    } else if (slug === "failure") {
      store.dispatch(
        createAlert({
          uuid: "FETCH_STRIPE",
          type: "error",
          content: "Stripe verification did not work, Please try again",
          timeout: 10000,
        })
      );
    }
  }

  handleClick = (e) => {
    StripeRepository.expressRegistration().subscribe((res) => {
      window.location = res.data.url;
    });
  };
  handleLogin = (e) => {
    StripeRepository.getStripeLogin().subscribe((res) => {
      window.location = res.data.redirect_url;
    });
  };
  render() {
    return (
      <div>
        {!st.authorize.company.stripe_id ? (
          <Grid>
            <Grid.Column width={12}>
              <p
                dangerouslySetInnerHTML={{
                  __html: I18n.t("papp.settings.StripeSettingsView.line1_html", {
                    interpolation: { escapeValue: false },
                  }),
                }}
              />

              <p
                dangerouslySetInnerHTML={{
                  __html: I18n.t("papp.settings.StripeSettingsView.line2_html", {
                    interpolation: { escapeValue: false },
                  }),
                }}
              />

              <p>{I18n.t("papp.settings.StripeSettingsView.line3")}</p>

              <List ordered>
                <List.Item>{I18n.t("papp.settings.StripeSettingsView.line3_1")}</List.Item>
                <List.Item>{I18n.t("papp.settings.StripeSettingsView.line3_2")}</List.Item>
                <List.Item>{I18n.t("papp.settings.StripeSettingsView.line3_3")}</List.Item>
                <List.Item>{I18n.t("papp.settings.StripeSettingsView.line3_4")}</List.Item>
              </List>

              <p
                dangerouslySetInnerHTML={{
                  __html: I18n.t("papp.settings.StripeSettingsView.line4_html", {
                    interpolation: { escapeValue: false },
                  }),
                }}
              />

              <p
                dangerouslySetInnerHTML={{
                  __html: I18n.t("papp.settings.StripeSettingsView.line5_html", {
                    interpolation: { escapeValue: false },
                  }),
                }}
              />

              <p
                dangerouslySetInnerHTML={{
                  __html: I18n.t("papp.settings.StripeSettingsView.line6_html", {
                    interpolation: { escapeValue: false },
                  }),
                }}
              />

              <p>
                <Button primary as="a" onClick={this.handleClick}>
                  {I18n.t("pl.papp.settings.StripeSettingsView.stripe_register_button")}
                </Button>
              </p>

              <p>{I18n.t("papp.settings.StripeSettingsView.line7")}</p>
            </Grid.Column>
          </Grid>
        ) : (
          <Grid>
            <Grid.Column width={12}>
              <p>{I18n.t("papp.settings.StripeSettingsView.stripe_verification")}</p>
              <p>
                <Button as="a" onClick={this.handleLogin}>
                  {I18n.t("pl.papp.settings.StripeSettingsView.stripe_login_button")}
                </Button>
              </p>
              <p>{I18n.t("papp.settings.StripeSettingsView.line7")}</p>
            </Grid.Column>
          </Grid>
        )}
      </div>
    );
  }
}

const BillingSettingsView = createStripeSettingsView({
  stateSelector,
  actions: { initializeView, updateModel, submit },
  title: I18n.t("papp.settings.StripeSettingsView.title"),
  FormContent,
  Hint,
});

export default BillingSettingsView;



// WEBPACK FOOTER //
// ./src/modules/settings/StripeSettingsView/StripeSettingsView.jsx